const API_URL = process.env.REACT_APP_API_URL;

// Get all news items (for admin)
export const getAllNews = async () => {
  try {
    const response = await fetch(`${API_URL}/api/news`);
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch news');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Get active news items (for frontend)
export const getActiveNews = async () => {
  try {
    const response = await fetch(`${API_URL}/api/news/active`);
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch active news');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Get single news item by ID
export const getNewsById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/api/news/${id}`);
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch news item');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Create new news item
export const createNews = async (newsData) => {
  try {
    const response = await fetch(`${API_URL}/api/news`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(newsData),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to create news item');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Update news item
export const updateNews = async (id, newsData) => {
  try {
    const response = await fetch(`${API_URL}/api/news/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(newsData),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to update news item');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Deactivate news item
export const deactivateNews = async (id) => {
  try {
    const response = await fetch(`${API_URL}/api/news/${id}/deactivate`, {
      method: 'PATCH',
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to deactivate news item');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Toggle news item active status
export const toggleNewsActive = async (id) => {
  try {
    const response = await fetch(`${API_URL}/api/news/${id}/toggle-active`, {
      method: 'PATCH',
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to toggle news active status');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Delete news item
export const deleteNews = async (id) => {
  try {
    const response = await fetch(`${API_URL}/api/news/${id}`, {
      method: 'DELETE',
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to delete news item');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};